import types from '@/store/types/Dominios'
import Vue from 'vue';


const state = {
  horario: {
    horaAtencion: '',
    horaFin: ''
  }
}
const getters = {
  [types.getters.GetHorarioAtencion]: (state) => {
    return state.horario;
  },
}
const mutations = {
  [types.mutations.SetHorarioAtencion]: (state, horaAtencion, horaFin) => {
    state.horario.horarioAtencion = horaAtencion;
    state.horario.horaFin = horaFin;
  },
}
const actions = {
  [types.actions.ObtienerCriterioDominios]: ({ commit }, pObj) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get(`consultas/criterios?entero=${pObj.dominioAgrupadorId}&cadena=${pObj.Criterio}`).then(r => {
        resolve(r);
      })
    })
  },
  [types.actions.ObtienerDominios]: ({ commit }, pDominio) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get(`dominio/list/${pDominio}`).then(r => {
        resolve(r);
      })
    })
  },
  [types.actions.ObtenerHorarioAtencion]: ({ commit }, pOficinaId) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get(`dominio/horarioAtencion/${pOficinaId}/${process.env.VUE_APP_SUSBSISTEMA}`).then(r => {
        resolve(r)
      })
    })
  }
}
export default {
  state,
  actions,
  getters,
  mutations
}
